var _g, _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTextFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4722_40286)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.43599 3.08571C4.43599 1.70106 5.55848 0.578571 6.94314 0.578571H17.0326L26.2789 9.92532V27.9143C26.2789 29.2989 25.1564 30.4214 23.7717 30.4214H6.94314C5.55848 30.4214 4.43599 29.2989 4.43599 27.9143V3.08571Z",
    fill: "white",
    stroke: "#C8D2E1",
    strokeWidth: 1.15714
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9727 0.769531V7.71239C16.9727 8.99053 18.0088 10.0267 19.2869 10.0267H26.2298",
    stroke: "#C8D2E1",
    strokeWidth: 1.15714,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14.6562,
    width: 19.8571,
    height: 12.0857,
    rx: 1.54286,
    fill: "#344054"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.44581 18.5668V17.5888H7.05356V18.5668H5.33593V23.1992H4.16344V18.5668H2.44581ZM8.77032 17.5888L9.90171 19.501H9.94554L11.0824 17.5888H12.422L10.7098 20.394L12.4604 23.1992H11.0961L9.94554 21.2843H9.90171L8.75114 23.1992H7.39238L9.14836 20.394L7.42525 17.5888H8.77032ZM12.8046 18.5668V17.5888H17.4124V18.5668H15.6948V23.1992H14.5223V18.5668H12.8046Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4722_40286"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.1429,
    height: 30.8571,
    fill: "white",
    transform: "translate(3.85742)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFileIcon);
export default __webpack_public_path__ + "static/media/textFileIcon.a15157a4d7d4d773c1eefadd68cc05fb.svg";
export { ForwardRef as ReactComponent };